import React from 'react';
import PushPinRoundedIcon from '@mui/icons-material/PushPinRounded';
import { COLOR_RED_LIGHT } from 'src/const';

const CenterPointer = ({ lat, lng, CustomIcon }: { lat: number; lng: number; CustomIcon?: any; }) => {
  const style = { color: COLOR_RED_LIGHT, fontSize: '32px', transform: 'translate(-50%,-50%)' };

  return (
    <div>      
      {CustomIcon ? <CustomIcon sx={style} /> : <PushPinRoundedIcon sx={style} />}
    </div>
  );
};

export default CenterPointer;
